import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

function PrivacyPolicy() {
  return (
    <>
      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto px-4">
        <Breadcrumbs />
      </div>

      {/* Hero Section */}
      <div className="bg-gray-100 py-12 mb-10">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold text-blue-700 mb-2">Privacy Policy</h1>
          <p className="text-gray-600 text-sm">
            Learn how we collect, use, and safeguard your information when you shop with us.
          </p>
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-4xl mx-auto px-4 pb-12 text-gray-700 text-sm leading-relaxed">
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            1. Information We Collect
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Identity details such as name (and optional gender).</li>
            <li>Contact information including email, phone number, and delivery address.</li>
            <li>Order details including purchased products and delivery information.</li>
            <li>Account login credentials — stored securely using encryption.</li>
            <li>Device information such as IP address for fraud prevention.</li>
            <li>
              Payment information is <strong>not</strong> stored by us — payments are 
              securely handled by Stripe and PayPal.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            2. How We Use Your Information
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>To fulfill orders and manage delivery schedules.</li>
            <li>To process secure payments using trusted providers.</li>
            <li>To support account login and provide a better shopping experience.</li>
            <li>To communicate order updates, confirmations, and support replies.</li>
            <li>
              To protect against fraud and maintain platform safety.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            3. Cookies & Tracking
          </h2>
          <p>
            We use necessary cookies for secure login, payment processing, and cart
            functionality. You can manage or delete cookies anytime in your browser
            settings.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            4. Data Security & Storage
          </h2>
          <p>
            We protect personal data with encryption and secure systems. We keep your
            information only as long as needed for order history, legal compliance, and
            account servicing. You may request data deletion at any time.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            5. Third-Party Service Providers
          </h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Stripe and PayPal — payment processing</li>
            <li>Email service providers — sending order-related emails</li>
            <li>Hosting providers — secure website operation</li>
          </ul>
          <p className="mt-2">
            We do <strong>not</strong> sell customer information to any third party.
          </p>
        </section>

        {/* Back to Home Link */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:underline text-sm font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default PrivacyPolicy;
